import React, { useState, useEffect } from 'react';
import desktopBg from '../assests/HPE/updated-assets/d_img.webp';
import mobileBg from '../assests/HPE/updated-assets/mobile.webp';

const LiveSoon = () => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(min-width: 768px)');
    const handler = (e) => setIsDesktop(e.matches);
    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  const bgImage = isDesktop ? desktopBg : mobileBg;

  return (
    <div
      className="relative flex w-screen h-screen justify-center items-center bg-grey-02 bg-center bg-cover bg-no-repeat before:absolute before:inset-0 before:bg-[linear-gradient(0deg,rgba(0,0,0,0.20)_0%,rgba(0,0,0,0.20)_100%),linear-gradient(90deg,rgba(0,0,0,0.90)_-10.69%,rgba(0,0,0,0.18)_73.43%)] before:z-0"
      style={{
        backgroundImage: `url(${bgImage})`,
      }}
    >
      <div className="z-10 flex w-full max-w-[552px] px-4 py-8 md:px-12 md:py-8 flex-col items-start gap-3 md:gap-4 shrink-0 self-center mx-auto">
        <h1
          className="self-stretch text-white text-center not-italic !font-semibold m-0"
        >
          We'll Be Live Soon
        </h1>
        <p
          className="b3 self-stretch text-white text-center not-italic m-0"
        >
          This page is currently under preparation and will be available soon.<br className="hidden md:block" /> Please check back shortly.
        </p>
      </div>
    </div>
  );
};

export default LiveSoon;
